module.exports = __webpack_public_path__ + "static/tally-7a0e250b51a98697f5f056e6997a60c5.png";